import { Layout } from 'components/index'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { getHistorystatement, getRaportData } from "service/StatementsService";
import { setStatementById } from 'store/slices/StatementsSlice'
import SimpleRaports from './components/SimpleRaports/SimpleRaports'

import userInfo from 'utils/userInfo'

const StatementInfo = () => {
  const [data, setData] = useState([])
  const [render, setRender] = useState(false)
  const dispatch = useDispatch()
  const user = userInfo()
  const { id } = useParams()
  const navigate = useNavigate();
  const location = useLocation()
  const [history, setHistory] = useState('');
  const getData = async (id) => {
    try {
      let response = await getRaportData(id, data)
      let response1 = await getHistorystatement(response.data?.id)
      setHistory(response1.daa)
      dispatch(
        setStatementById({
          statementId: response.data,
        }),
        setHistory({ history: response1.data,})
      );
    } catch (error) {
      console.log("CHU")
    }
  }

  useEffect(() => {
    if (location.state && location.state.usedId) {
      const usedId = location.state.usedId;
      
      getData(usedId);
      setRender(false);
    } else {

      navigate("/home");
    }
  }, [render, location.pathname, location.state]);

  const items = useSelector((state) => state.statement)
  const simpleinfo = items.statementId

  return (
    <Layout>
      <SimpleRaports render = {render} history = {history}  info={simpleinfo} setRender={setRender} />
    </Layout>
  )
}

export default StatementInfo
